import { useEffect, useRef, useState } from 'react';
import { FAMILY_SPACE_UPSALE_TOOLTIP_SHOWN } from 'reactApp/sections/QuotaLanding/multiTariffUpsaleDialog/tooltip/FamilySpaceUpsaleTooltip';

// eslint-disable-next-line unused-imports/no-unused-vars
let timeout;

function setSessionTooltipVisibilityStatus() {
    sessionStorage.setItem(FAMILY_SPACE_UPSALE_TOOLTIP_SHOWN, 'true');
}

function getSessionTooltipVisibilityStatus() {
    return sessionStorage.getItem(FAMILY_SPACE_UPSALE_TOOLTIP_SHOWN);
}

export const useFamilySpaceTooltip = (isFamilySpaceUpsale) => {
    const tooltipRef = useRef<HTMLDivElement | null>(null);
    const [showTooltip, setShowTooltip] = useState<boolean>(false);

    useEffect(() => {
        if (isFamilySpaceUpsale && !getSessionTooltipVisibilityStatus()) {
            timeout = setTimeout(() => {
                setShowTooltip(true);
                setSessionTooltipVisibilityStatus();
            }, 3000);
        }
    }, [isFamilySpaceUpsale]);

    return { tooltipRef, showTooltip, setShowTooltip };
};
